<div class="custom-dropdown relative w-full grid gap-y-1 flex-col">
  <div
    class="dropdown-toggle flex px-4 items-center gap-2 h-12 rounded border border-solid"
    [ngClass]="{
      'justify-end': !control?.value,
      'justify-between': control?.value,
      'cursor-not-allowed': control?.disabled,
      'cursor-pointer': !control?.disabled,
      'border-color-light-shade': (!control?.invalid || control?.pristine) && !control?.disabled,
      'border-[#00000012]': control?.disabled,
      'border-color-danger': control?.invalid && control?.dirty,
    }"
    [matTooltip]="fcTooltip"
    [matTooltipDisabled]="fcTooltipDisabled"
    [matTooltipPosition]="fcTooltipPosition"
    (click)="toggleDropdown()"
  >
    <span
      class="absolute label leading-3 text-sm bg-color-primary-contrast"
      [ngClass]="{
        'label-float text-xs': control?.value?.name,
        'text-color-secondary': !control?.disabled && control?.value?.name,
        'text-[#00000061]': control?.disabled,
        'text-color-medium': (!control?.invalid || control?.pristine) && !control?.disabled,
        'text-color-danger': control?.invalid && control?.dirty,
      }"
    >
      {{ placeholder }}
      @if (isRequired) {
        *
      }
    </span>
    <div class="grid items-center gap-x-2 selected-value-hide w-full" [ngClass]="{ 'selected-value-show': control?.value }">
      @if (showImage) {
        <img
          (error)="control.value.avatarUrl = null"
          [src]="control?.value?.avatarUrl || 'https://ui-avatars.com/api/?name=' + (control?.value?.name || '')"
          [alt]="control?.value?.name"
          class="w-6 h-6 rounded-full"
        />
      }
      <span
        tooltipWhenTruncated="{{ control?.value?.name }}"
        matTooltip
        [ngClass]="{ 'text-[#00000061]': control?.disabled, 'text-color-normal': !control?.disabled }"
        class="truncate w-full text-sm"
      >
        {{ control?.value?.name }}
      </span>
    </div>
    <mat-icon
      [ngClass]="{
        'text-[#FC3869]': control?.invalid && control?.dirty,
        'text-color-secondary': (!control?.invalid || control?.pristine) && !control?.disabled,
        'text-[#00000061]': control?.disabled,
      }"
      >arrow_drop_down</mat-icon
    >
  </div>
  @if (isOpen()) {
    <div
      class="dropdown-content absolute w-full rounded bg-color-primary-contrast border-solid border"
      [ngClass]="{
        above: isOptionsAbove,
        below: !isOptionsAbove,
        'border-color-light-shade': !control?.disabled,
        'border-[#00000012]': control?.disabled,
      }"
    >
      <div
        class="flex items-center gap-2 px-4 border-solid border-0"
        [ngClass]="{
          'border-t': isOptionsAbove,
          'border-b': !isOptionsAbove,
          'border-color-border-medium-contrast': !control?.disabled,
          'border-[#00000012]': control?.disabled,
        }"
      >
        <mat-icon class="text-color-primary shrink-0">search</mat-icon>
        <input
          #inputElement
          class="text-sm focus:outline-none h-12 placeholder-color-medium grow border-transparent min-w-0"
          type="text"
          [formControl]="searchTerm"
          [placeholder]="searchPlaceholder || 'FC_SELECT.PLACEHOLDER' | translate"
          (input)="scrollbarRef.scrollTo({ top: 0 })"
        />
        <mat-icon class="text-color-primary cursor-pointer hover:text-opacity-80 shrink-0" (click)="removeSelectedItem()">
          highlight_off
        </mat-icon>
      </div>
      @if (isLoading()) {
        <mat-progress-bar class="w-full" mode="indeterminate"></mat-progress-bar>
      }
      <ul #optionsList class="options-list list-none m-0 p-0">
        <ng-scrollbar
          #scrollbarRef
          (updated)="onScrollbarUpdate(scrollbarRef)"
          [visibility]="'hover'"
          autoHeightDisabled="false"
          class="max-h-[262px]"
        >
          @if (!options().length && !isLoading()) {
            <li class="flex items-center gap-x-2 text-color-normal text-sm py-3 px-4">
              {{ 'FC_SELECT.NO_OPTIONS_FOUND' | translate }}
            </li>
          }
          @if (!isLoading()) {
            <ng-content></ng-content>
          }
          @for (item of options(); track $index) {
            <li
              [class.selected]="item === control?.value"
              class="flex items-center gap-x-2 text-color-normal hover:bg-color-light text-sm py-3 px-4 cursor-pointer"
              (click)="selectItem(item)"
            >
              @if (showImage) {
                <img
                  appImageLoad
                  (error)="item.avatarUrl = null"
                  [src]="item.avatarUrl || 'https://ui-avatars.com/api/?name=' + (item?.name || '')"
                  alt="item.name"
                  class="w-6 h-6 rounded-full"
                />
              }
              <span tooltipWhenTruncated="{{ item.name }}" matTooltip class="truncate">{{ item.name }}</span>
            </li>
          }
        </ng-scrollbar>
      </ul>
    </div>
  }
</div>
